import RootState from 'typings/RootState'
import { Event } from '../../types/event'
import { DataList, DataDetail } from './types'

export const selectEvent = (state: RootState): Event =>
  state.adminReportAuditPlan.Event

export const selectReportList = (state: RootState): DataList =>
  state.adminReportAuditPlan.DataList

export const selectReportDetail = (state: RootState): DataDetail =>
  state.adminReportAuditPlan.DataDetail

export const selectFilter = (state: RootState) =>
  state.adminReportAuditPlan.Filter

export const selectInitFilter = (state: RootState) =>
  state.adminReportAuditPlan.ClearFilter

export const selectSorting = (state: RootState) =>
  state.adminReportAuditPlan.sorting
